export function shouldShowGoToTopButton({
  scrollOffset,
  mobileSectionsMenuOpen,
  mobileViewport,
}) {
  const mobileSectionsMenuBlocksButton =
    mobileViewport && mobileSectionsMenuOpen;

  return scrollOffset > 400 && !mobileSectionsMenuBlocksButton;
}
